var React = require('react');

function IconOrderHistory (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 7V12H17","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.8588 13.2278L5.49072 16.9866L1.73195 15.6185","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M5.51075 16.9928C4.55641 15.5642 4 13.8471 4 12C4 7.02944 8.02944 3 13 3C17.9706 3 22 7.02944 22 12C22 16.9706 17.9706 21 13 21C11.1529 21 9.43584 20.4436 8.00717 19.4892","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

IconOrderHistory.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = IconOrderHistory;

IconOrderHistory.default = IconOrderHistory;
